// /resources/js/wallet-login.js

// This file ONLY imports what the wallet login page needs.
import { walletAuthController } from './wallet-auth-controller.js';

document.addEventListener('DOMContentLoaded', () => {
    walletAuthController.init({
        mode: 'auth',
        buttonId: 'wallet-auth-btn',
        statusElementId: 'wallet-auth-status',
        inviteCodeElementId: 'invite_code'
    });
});